export const CommonAccordionCardData = [
  {
    id: 1,
    heading: "Filter",
    data: [
      {
        id: "chk-ani",
        title: "Full-time (8688)",
      },
      {
        id: "chk-ani1",
        title: "Contract (503)",
      },
      {
        id: "chk-ani2",
        title: "Part-time (288)",
      },
      {
        id: "chk-ani3",
        title: "Internship (236)",
      },
      {
        id: "chk-ani4",
        title: "Temporary (146)",
      },
      {
        id: "chk-ani5",
        title: "Commission (25)",
      },
    ],
    buttonTitle: "Find Jobs",
  },
  {
    id: 2,
    heading: "Location",
    data: [
      {
        id: "chk-ani6",
        title: "New York",
        subTitle: "NY (399)",
      },
      {
        id: "chk-ani7",
        title: "San Francisco",
        subTitle: "CA (252)",
      },
      {
        id: "chk-ani8",
        title: "Washington",
        subTitle: "DC (226)",
      },
      {
        id: "chk-ani9",
        title: "Seattle",
        subTitle: "WA (242)",
      },
      {
        id: "chk-ani10",
        title: "Chicago",
        subTitle: "IL (187)",
      },
    ],
    buttonTitle: "All Locations",
  },
  {
    id: 3,
    heading: "Job Title",
    data: [
      {
        id: "chk-ani11",
        title: "UI/Ux designer(25)",
      },
      {
        id: "chk-ani12",
        title: "Graphic designer(10)",
      },
      {
        id: "chk-ani13",
        title: "Front end designer(15)",
      },
      {
        id: "chk-ani14",
        title: "PHP developer(42)",
      },
      {
        id: "chk-ani15",
        title: "React Developer(5)",
      },
    ],
    buttonTitle: "All Job Title",
  },
  {
    id: 4,
    heading: "Industry",
    data: [
      {
        id: "chk-ani16",
        title: "Computer Software(14)",
      },
      {
        id: "chk-ani17",
        title: "IT Engineer(10)",
      },
      {
        id: "chk-ani18",
        title: "Service industry(20)",
      },
      {
        id: "chk-ani19",
        title: "Accounting(34)",
      },
      {
        id: "chk-ani20",
        title: "Financial Services(5)",
      },
    ],
    buttonTitle: "All Industries",
  },
  {
    id: 5,
    heading: "Specific Skills",
    data: [
      {
        id: "chk-ani21",
        title: " HTML,scss & sass",
      },
      {
        id: "chk-ani22",
        title: " Javascript",
      },
      {
        id: "chk-ani23",
        title: "Node.js",
      },
      {
        id: "chk-ani24",
        title: "Gulp & Pug",
      },
      {
        id: "chk-ani25",
        title: "Angular.js",
      },
    ],
    buttonTitle: "All Skills",
  },
];

export const JobDescriptionData = [
  {
    id: 1,
    title: "Qualifications",
    child: [
      { id: 1, list: "Have shipped multiple iOS, Android, and/or web products " },
      { id: 2, list: "5+ years UI/UX experience" },
      { id: 3, list: "Portfolio demonstrating mastery of native iOS, Android, and/or responsive web design principles" },
      { id: 4, list: "Ability to autonomously pursue elegant solutions to open-ended problems" },
      { id: 5, list: "Comfort with ambiguity" },
      { id: 6, list: "Proven ability to create interactive prototypes" },
      { id: 7, list: "Strong verbal communication skills with ability to clearly communicate complex ideas and champion a design vision across all levels of an organization" },
      { id: 8, list: "Strong written communication skills with ability to make transparent design documentation and client-facing presentations" },
      { id: 9, list: "Ability to create and maintain flow charts, wire frames, prototypes, and mockups." },
      { id: 10, list: "Ability to effectively work on more than one project at a time" },
      { id: 11, list: "Experience conducting user research and stakeholder interviews" },
      { id: 12, list: "Solid grasp of standard design tools, ex: Sketch, Omnigraffle, the Adobe Suite, Zeplin, etc." },
      { id: 13, list: "Bonus Considerations " },
    ],
  },
  {
    id: 2,
    title: "Agency experience",
    child: [
      { id: 1, list: "Experience working with Agile development teams" },
      { id: 2, list: "Experience with RITE method usability testing" },
      { id: 3, list: "Experience in visual and motion design; ability to translate UX design into high quality visuals" },
      { id: 4, list: "Mastery of Sketch & InVision" },
      { id: 5, list: "Knowledge of mobile or front-end web programming" },
    ],
  },
  {
    id: 3,
    title: "Perks",
    child: [
      { id: 1, list: "Competitive pay" },
      { id: 2, list: "Competitive medical, dental, and vision insurance plans" },
      { id: 3, list: "Company-provided 401(k) plan" },
      { id: 4, list: "Paid vacation and sick time" },
      { id: 5, list: "Free snacks and beverages" },
    ],
  },
];

export const RightSidebarCardsData = [
  {
    id: 1,
    logo: "1.jpg",
    job_name: "UI/UX IT Frontend Developer",
    badgeValue: true,
    job_area: "(L6) Salt Lake City",
    job_city: "UT",
    job_description: "We are looking for an experienced and yuri designer and/or frontend engineer with expertise in accessibility to join our team , 3+ years of experience working in as a Frontend Engineer or comparable role. You won’t be a team of one though — you’ll be collaborating closely with other...",
    type: "New",
    ribbon: false,
  },
  {
    id: 2,
    logo: "2.jpg",
    job_name: "React/React Native Developer",
    badgeValue: true,
    job_area: "San",
    job_city: "Diego, CA",
    job_description: "Ideally 2+ years experience with React. Bonus points if you have React Native experience. This is an incredibly exciting opportunity to gain commercial , Professional experience of React Native and other front end frameworks. Transform product wireframes into responsive, mobile user interface",
    type: "New",
    ribbon: false,
  },
  {
    id: 3,
    logo: "3.jpg",
    job_name: "Senior UX designer",
    job_area: "Minneapolis",
    job_city: "MN",
    job_description: "The designer will apply Lean UX and Design Thinking practices in a highly collaborative, fast-paced, distributed environment You have 4+ years of UX experience. You support UX leadership by providing continuous feedback regarding the evolution of team process standards",
    type: "2 days ago",
    ribbon: true,
  },
  {
    id: 4,
    logo: "4.jpg",
    job_name: "Front-end Web Developer",
    job_area: "Cisco",
    job_city: "Lelystad, Netherlands",
    job_description: "Insipidity the sufficient discretion imprudence resolution sir him decisively. Proceed how any engaged visitor. Explained propriety off out perpetual his you. Feel sold off felt nay rose met you. We so entreaties cultivated astonished is. Was sister for few longer mrs sudden talent become.",
    type: "3 days ago",
    ribbon: false,
  },
  {
    id: 5,
    logo: "5.jpg",
    job_name: "Graphic designer",
    job_area: "Infosys",
    job_city: "Lelystad, Netherlands",
    job_description: "Although UI and UX are frequently used synonymously, they really refer to two separate concepts. 'User interface' or 'UI' refers to a product's or website's visual components. Layout, colour scheme, typography, and general aesthetics are covered in this section.",
    type: "3 days ago",
    ribbon: false,
  },
  {
    id: 6,
    logo: "6.jpg",
    job_name: "Designer, CRM",
    job_area: "Citrix",
    job_city: "Lelystad, Netherlands",
    job_description: "Situation admitting promotion at or to perceived be. Mr acuteness we as estimable enjoyment up. An held late as felt know. Learn do allow solid to grave. Middleton suspicion age her attention. Chiefly several bed its wishing. Is so moments on chamber pressed to.",
    type: "3 days ago",
    ribbon: false,
  },
  {
    id: 7,
    logo: "2.jpg",
    job_name: "React/React Native Developer",
    job_area: "San",
    job_city: "Diego, CA",
    job_description: "Ideally 3+ years experience with React. Bonus points if you have React Native experience. This is an incredibly exciting opportunity to gain commercial , Professional experience of React Native and other front end frameworks. Transform product wireframes into responsive",
    type: "5 days ago",
    ribbon: true,
  },
  {
    id: 8,
    logo: "3.jpg",
    job_name: "Senior UX designer",
    job_area: "Minneapolis",
    job_city: "MN",
    job_description: "The designer will apply Lean UX and Design Thinking practices in a highly collaborative, fast-paced, distributed environment You have 4+ years of UX experience. You support UX leadership by providing continuous feedback regarding the evolution of team process standards",
    type: "5 days ago",
    ribbon: false,
  },
  {
    id: 9,
    logo: "5.jpg",
    job_name: "Graphic designer",
    job_area: "Infosys",
    job_city: "Lelystad, Netherlands",
    job_description: "Contented get distrusts certainty nay are frankness concealed ham. On unaffected resolution on considered of. No thought me husband or colonel forming effects. End sitting shewing who saw besides son musical adapted. Contrasted interested eat alteration pianoforte sympathize was.",
    type: "3 days Ago",
    ribbon: false,
  },
  {
    id: 10,
    logo: "6.jpg",
    job_name: "Designer, CRM",
    job_area: "Citrix",
    job_city: "Lelystad, Netherlands",
    job_description: "Situation admitting promotion at or to perceived be. Mr acuteness we as estimable enjoyment up. An held late as felt know. Learn do allow solid to grave. Middleton suspicion age her attention. Chiefly several bed its wishing. Is so moments on chamber pressed to. Doubtful yet way properly answered.",
    type: "3 days Ago",
    ribbon: false,
  },
  {
    id: 11,
    logo: "1.jpg",
    job_name: "UI/UX IT Frontend Developer",
    badgeValue: true,
    job_area: "(L6) Salt Lake City",
    job_city: "UT",
    job_description: "We are looking for an experienced and yuri designer and/or frontend engineer with expertise in accessibility to join our team , 3+ years of experience working in as a Frontend Engineer or comparable role. You won’t be a team of one though — you’ll be collaborating closely with other...",
    type: "New",
    ribbon: false,
  },
  {
    id: 12,
    logo: "2.jpg",
    job_name: "React/React Native Developer",
    badgeValue: true,
    job_area: "San",
    job_city: "Diego, CA",
    job_description: "Ideally 1+ years experience with React. Bonus points if you have React Native experience. This is an incredibly exciting opportunity to gain commercial , Professional experience of React Native and other front end frameworks. Transform product wireframes into responsive, mobile user interface",
    type: "New",
    ribbon: false,
  },
  {
    id: 13,
    logo: "4.jpg",
    job_name: "Front-end Web Developer",
    job_area: "Cisco",
    job_city: "Lelystad, Netherlands",
    job_description: "Insipidity the sufficient discretion imprudence resolution sir him decisively. Proceed how any engaged visitor. Explained propriety off out perpetual his you. Feel sold off felt nay rose met you. We so entreaties cultivated astonished is. Was sister for few longer mrs sudden talent become.",
    type: "3 days ago",
    ribbon: false,
  },
  {
    id: 14,
    logo: "3.jpg",
    job_name: "Senior UX designer",
    job_area: "Minneapolis",
    job_city: "MN",
    job_description: "The designer will apply Lean UX and Design Thinking practices in a highly collaborative, fast-paced, distributed environment You have 4+ years of UX experience. You support UX leadership by providing continuous feedback regarding the evolution of team process standards",
    type: "2 days ago",
    ribbon: true,
  },
];

export const Months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

export const Days = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31"];

export const Years = ["1985", "1986", "1987", "1988", "1989", "1990", "1991", "1992", "1993", "1994", "1995", "1996", "1997", "1998", "1999", "2000", "2001", "2002", "2003", "2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015"];

export const DegreeLevelData = ["Student", "Bachelor", "Master", "Associate"];

export const Positions = ["Web Designer", "Graphic Designer", "UI Designer", "UI/UX Designer"];
